module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tabletPro-en.836899d4.webp";